<template>
  <!-- <b-container> -->
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />

    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('bi.sidebar.shortTitle')"
      :logo="$store.getters.systemLogoSidebar"
      :titleImg="$store.getters.systemTitleImage"
      :title="$store.getters.systemTile"
    >
      <template slot="links" v-if="type == 1">
        <sidebar-item
          :link="{
            name: 'Formulários',
            icon: 'tim-icons icon-notes',
            path: '/module/forms/' + moduleId,
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$store.getters.isChecklistPendenciesView"
          ref="sidebarItemPendencies"
          :link="{
            name: $t('checklist.sidebar.Pendencies'),
            icon: 'tim-icons icon-alert-circle-exc',
          }"
        >
          <sidebar-item
            :link="{
              name: $t('checklist.sidebar.pendenciesOpened'),
              path: '/module/pendencies/opened/' + moduleId,
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('checklist.sidebar.pendenciesApproved'),
              path: '/module/pendencies/approved/' + moduleId,
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
          <sidebar-item
            :link="{
              name: $t('checklist.sidebar.pendenciesExpired'),
              path: '/module/pendencies/expired/' + moduleId,
              icon: 'tim-icons icon-alert-circle-exc',
            }"
          />
        </sidebar-item>
        <div v-for="view in views" :key="view.id">
          <sidebar-item
            v-if="view.formId != null"
            ref="sidebarItemForms"
            :link="{
              name: view.formName,
              icon: 'tim-icons icon-paper',
            }"
          >
            <sidebar-item
              :link="{
                name: 'Preenchidos',
                path: '/modulo/' + moduleId + '/' + view.id,
              }"
            >
            </sidebar-item>
            <sidebar-item
              :link="{
                name: 'Preencher',
                path: '/module/fillForm/' + moduleId + '/' + view.formId,
              }"
            >
            </sidebar-item>
            <sidebar-item
              :link="{
                name: 'Meus rascunhos',
                path: '/module/layout/draft/' + moduleId + '/' + view.formId,
              }"
            >
            </sidebar-item>
          </sidebar-item>
          <sidebar-item
            v-if="view.powerBiViewId != null"
            :link="{
              name: view.biName,
              icon: 'tim-icons icon-chart-pie-36',
              path: '/modulo/' + moduleId + '/' + view.id,
            }"
          >
          </sidebar-item>
        </div>
      </template>
      <template slot="links" v-if="type == 2">
        <!-- <sidebar-item
          :link="{
            name: 'BI',
            icon: 'tim-icons icon-chart-pie-36',
            path: '/module/bi/' + moduleId,
          }"
        >
        </sidebar-item> -->
        <div v-for="view in views" :key="view.id">
          <sidebar-item
            v-if="view.powerBiViewId != null"
            :link="{
              name: view.biName,
              icon: 'tim-icons icon-chart-pie-36',
              path: '/modulo/' + moduleId + '/' + view.id,
            }"
          >
          </sidebar-item>
        </div>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar module="BI"></dashboard-navbar>
      <router-view name="header"></router-view>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
  <!-- </b-container> -->
</template>
<script>
import { ZoomCenterTransition } from "vue2-transitions";
import SidebarFixedToggleButton from "../../../pages/Layout/SidebarFixedToggleButton.vue";

import ContentFooter from "../../../pages/Layout/ContentFooter.vue";
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}
export default {
  components: {
    DashboardNavbar: () => import("@/pages/Layout/DashboardNavbar.vue"),
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition,
    ModuleView: () => import("./ModuleView.vue"),
  },
  props: {
    moduleId: String,
    id: String,
  },
  data() {
    return {
      sidebarBackground: "primary",
      views: [],
      type: 0,
    };
  },
  created() {
    this.loadData();
    this.getModuleType();
  },
  mounted() {
    this.initScrollbar();
    if (this.$refs.sidebarItemForms) {
      if (this.$refs.sidebarItemForms.collapsed) {
        this.$refs.sidebarItemForms.collapseMenu();
      }
    }
    if (this.$refs.sidebarItemPendencies) {
      if (this.$refs.sidebarItemPendencies.collapsed) {
        this.$refs.sidebarItemPendencies.collapseMenu();
      }
    }
  },
  methods: {
    init() {
      if (this.views.length > 0) {
        let item = this.views[0];
        // console.log(item);
        this.$router.push("/modulo/" + this.moduleId + "/" + item.id);
      }
    },
    loadData() {
      this.$apiScheduler
        .post("/moduleMenu/all/" + this.moduleId)
        .then((response) => {
          this.views = response.data;
          this.$forceUpdate;
          if (this.id == undefined) {
            this.init();
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
    },
    getModuleType() {
      this.$apiScheduler
        .get("/module/get/" + this.moduleId)
        .then((response) => {
          console.log(response);
          this.type = response.data.type;
          console.log(this.type);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidebar");
        //initScrollbar("main-panel");
        initScrollbar("sidebar-wrapper");

        docClasses.add("perfect-scrollbar-off"); // docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
/* example */
.ps {
  height: 100%;
}
</style>